import { ProductSize, CaptionPosition, Brand } from "~/dataModels/ProductModels";


  export const convertPlateSizeTopDropdownOptions = (plateSizes: ProductSize[])=>{
    return plateSizes.map(ps=>{
        const {name,id,width,height} = ps;
        return {
            key: name,
            value: id,
            text: `${name} ${width}x${height}mm`
        }
    })

}


export const convertBrandsTopDropdownOptions = (brands: Brand[])=>{
  return brands.map(b=>{
      const {name,value} = b;
      return {
          key: value,
          value: value,
          text: name
      }
  })

}

export const convertCaptionPositionsToDropdownOptions = (positions: CaptionPosition[])=>{
    return positions.map(ps=>{
        const {text, value} = ps;
        return {
            key: value,
            value: value,
            text: text
        }
    })
}
